import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import MatchWordService from '../../services/matchwordServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('matchword/list', async (query, thunkAPI) => {
  try {
    const response = await MatchWordService.getList(query);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const copyMatchword = createAsyncThunk('matchword/copy', async ({ id, name, createdBy = null }, thunkAPI) => {
  try {
    const response = await MatchWordService.copyMatchword(id, name, createdBy);
    thunkAPI.dispatch(setMessage({ message: 'Matchword berhasil disalin', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getShares = createAsyncThunk('matchword/getShares', async (matchwordId, thunkAPI) => {
  try {
    const response = await MatchWordService.getShares(matchwordId);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getEligibleTeachers = createAsyncThunk('matchword/getEligibleTeachers', async (matchwordId, thunkAPI) => {
  try {
    const response = await MatchWordService.getEligibleTeachers(matchwordId);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getEligibleForCopy = createAsyncThunk('matchword/getEligibleForCopy', async (matchwordId, thunkAPI) => {
  try {
    const response = await MatchWordService.getEligibleForCopy(matchwordId);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const addShares = createAsyncThunk('matchword/addShares', async ({ matchwordId, teacherIds }, thunkAPI) => {
  try {
    const response = await MatchWordService.addShares(matchwordId, teacherIds);
    thunkAPI.dispatch(setMessage({ message: response.message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const removeShare = createAsyncThunk('matchword/removeShare', async ({ matchwordId, teacherId }, thunkAPI) => {
  try {
    const response = await MatchWordService.removeShare(matchwordId, teacherId);
    thunkAPI.dispatch(setMessage({ message: response.message || 'Akses berhasil dicabut', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getListArchive = createAsyncThunk('matchword/getListArchive', async (query, thunkAPI) => {
  try {
    const response = await MatchWordService.getListArchive(query);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('matchword/create', async (data, thunkAPI) => {
  try {
    const response = await MatchWordService.create(data);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('matchword/read', async (id, thunkAPI) => {
  try {
    const response = await MatchWordService.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateData = createAsyncThunk('matchword/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await MatchWordService.update(id, data);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('matchword/delete', async (id, thunkAPI) => {
  try {
    const response = await MatchWordService.del(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changeStatus = createAsyncThunk('matchword/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await MatchWordService.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getHistory = createAsyncThunk('matchword/getHistory', async (id, thunkAPI) => {
  try {
    const response = await MatchWordService.getHistory(id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getAlHistory = createAsyncThunk('matchword/getAlHistory', async (query, thunkAPI) => {
  try {
    const response = await MatchWordService.getAlHistory(query);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getSession = createAsyncThunk('matchword/getSession', async ({ id, sessionID }, thunkAPI) => {
  try {
    const response = await MatchWordService.getSession(id, sessionID);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getRatings = createAsyncThunk('matchword/getRatings', async ({ id, page, perPage, sort, orderBy }, thunkAPI) => {
  try {
    const response = await MatchWordService.getRatings(id, { page, perPage, sort, orderBy });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

const initialState = {
  isLoading: false,
  list: [],
  histories: null,
  data: [],
  ratings: null,
  error: [],
  group: {},
  session: [],
  shares: [],
  eligibleTeachers: [],
  eligibleForCopy: [],
  shareLoading: false
};

const matchwordSlice = createSlice({
  name: 'matchword',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(copyMatchword.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(copyMatchword.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(copyMatchword.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getShares.pending, (state) => {
        state.shareLoading = true;
        state.shares = [];
      }),
      builder.addCase(getShares.fulfilled, (state, action) => {
        state.shareLoading = false;
        state.shares = action.payload;
      }),
      builder.addCase(getShares.rejected, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(getEligibleTeachers.pending, (state) => {
        state.shareLoading = true;
        state.eligibleTeachers = [];
      }),
      builder.addCase(getEligibleTeachers.fulfilled, (state, action) => {
        state.shareLoading = false;
        state.eligibleTeachers = action.payload;
      }),
      builder.addCase(getEligibleTeachers.rejected, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(getEligibleForCopy.pending, (state) => {
        state.shareLoading = true;
        state.eligibleForCopy = [];
      }),
      builder.addCase(getEligibleForCopy.fulfilled, (state, action) => {
        state.shareLoading = false;
        state.eligibleForCopy = action.payload;
      }),
      builder.addCase(getEligibleForCopy.rejected, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(addShares.pending, (state) => {
        state.shareLoading = true;
      }),
      builder.addCase(addShares.fulfilled, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(addShares.rejected, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(removeShare.pending, (state) => {
        state.shareLoading = true;
      }),
      builder.addCase(removeShare.fulfilled, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(removeShare.rejected, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getAlHistory.pending, (state) => {
        state.isLoading = true;
        state.histories = null;
      }),
      builder.addCase(getAlHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.histories = action.payload;
      }),
      builder.addCase(getAlHistory.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.errors ?? [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
        state.data = null;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.errors ?? [];
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getHistory.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.group = action.payload.session;
      }),
      builder.addCase(getHistory.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getSession.pending, (state) => {
        state.isLoading = true;
        state.data = null;
        state.session = null;
      }),
      builder.addCase(getSession.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.session = action.payload.session;
      }),
      builder.addCase(getSession.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getRatings.pending, (state) => {
        state.isLoading = true;
        state.ratings = null;
      }),
      builder.addCase(getRatings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ratings = action.payload;
      }),
      builder.addCase(getRatings.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = matchwordSlice;
export default reducer;
